<template>
  <fragment>
    <v-card v-scroll="onScroll" flat>
      <div>
        <v-row
          v-if="activity.source !== 'NONE'"
          :class="{
            halightblue:
              activity.source === 'APPROVED' || activity.source === 'COMMUNITY',
            halightorange: activity.source === 'FAVORITE',
            hafsoftgrey: activity.source === 'EXTERNAL',
          }"
          class="justify-center"
        >
          <span class="white--text font-italic text-caption">{{
            activity.source | getTextCard
          }}</span>
        </v-row>
        <v-carousel height="50vh" hide-delimiters>
          <v-carousel-item
            v-for="(image, index) in activity.gallery_images"
            :key="index"
            :src="$config.staticUrl + image.optimized"
          ></v-carousel-item>
        </v-carousel>
        <div>
          <v-img
            v-if="activity.source === 'APPROVED'"
            class="badge-image-activity"
            :src="badge"
            alt="badge"
          ></v-img>
          <v-container fluid class="pa-0">
            <v-row class="buttons" :class="{ fixedbar: isScrollLimit }">
              <MarkComplete
                :is-completed="activity.completed"
                :activity-id="activity.id"
                :activity-headline="activity.headline"
                @change="openAppDownload"
              />
              <AddToCalendar
                tool-tip="Add to calendar"
                details="Details of event"
                :end-time="new Date()"
                :location="activity.address"
                :start-time="new Date()"
                :title="`Happyly adventure to ${activity.headline}`"
                @change="openAppDownload"
              />
              <Bookmark
                v-if="hasSubscription"
                category="activity"
                :object-id="activity.id"
                :resource-headline="activity.headline"
                large
                dark
                is-btn
                @change="openAppDownload"
              />
            </v-row>
            <v-row class="px-4">
              <v-col>
                <h1 class="font-weight-bold mb-2">
                  {{ activity.headline }}
                </h1>
                <h3 class="font-weight-thin">
                  <v-icon class="mr-2">mdi-map-marker-outline</v-icon
                  >{{ activity.address }}
                </h3>
                <h3 class="font-weight-thin">
                  <v-icon class="mr-2">mdi-clock-outline</v-icon
                  >{{ activity.hours }}
                </h3>
                <h3 class="font-weight-thin">
                  <v-icon class="mr-2">mdi-tag-outline</v-icon
                  ><span v-for="item in activity.price_range" :key="item"
                    >$</span
                  >
                </h3>
                <h3 class="font-weight-thin">
                  <v-icon class="mr-2">mdi-book-open-variant </v-icon
                  ><span
                    v-for="(tag, index) in activity.categories"
                    :key="tag"
                    >{{ index > 0 ? `, ${tag}` : tag }}</span
                  >
                </h3>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
    </v-card>
    <AppDownloadDialog
      :open-app-download-dialog="openAppDownloadDialog"
      @updateDialog="openAppDownloadDialog = $event"
    />
  </fragment>
</template>

<script>
import Bookmark from '@/components/profile/Bookmark'
import AddToCalendar from '@/components/AddToCalendar.vue'
import MarkComplete from '@/components/activity/MarkComplete.vue'
import AppDownloadDialog from '@/components/AppDownloadDialog.vue'

export default {
  name: 'ActivityHero',
  components: { Bookmark, AddToCalendar, MarkComplete, AppDownloadDialog },
  filters: {
    getTextCard(source) {
      switch (source) {
        case 'APPROVED':
          return 'happyly approved'
        case 'FAVORITE':
          return 'local ambassador favorite'
        case 'EXTERNAL':
          return 'not visited by happyly'
        case 'COMMUNITY':
          return 'Community Generated Content'
        default:
          return ''
      }
    },
    ellipsis(text, limit = 90) {
      if (text.length <= limit) return text
      return `${text.substring(0, limit)}...`
    },
  },
  props: {
    activity: {
      type: Object,
      default: () => {},
    },
    hasSubscription: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    badge: require('../../assets/images/badge.png'),
    scrollY: 0,
    open: false,
    openAppDownloadDialog: true,
  }),
  computed: {
    isScrollLimit() {
      return this.scrollY >= 480
    },
    src() {
      const root = this.$config.staticUrl
      if (this.activity.header_optimized) {
        return `${root}${this.activity.header_optimized}`
      } else if (this.activity.activity_types.length) {
        return `${root}${this.activity.activity_types[0].header_image}`
      } else {
        return null
      }
    },
  },
  methods: {
    onScroll() {
      this.scrollY = window.scrollY
    },
    onMarkChange(data) {
      this.$store
        .dispatch('activities/ACTIVITY_COMPLETE/REQUEST', data)
        .then(() => (this.open = true))
    },
    openAppDownload() {
      this.openAppDownloadDialog = true
    },
  },
}
</script>

<style lang="scss" scoped>
.badge-image-activity {
  width: 110px;
  height: 110px;
  position: absolute;
  top: 50px;
  left: 50px;
  z-index: 1;
}
.buttons {
  transition: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  margin-top: -28px;
}
.fixedbar {
  margin: 0;
  width: 100%;
  height: 70px;
  background-color: #276b6c;
  position: fixed;
  top: 85px;
  z-index: 1000;
  transition: background-color 1s;
}
.activity-props {
  max-width: 90%;
  max-height: 40px;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
